import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "bibliography", "file"];
  static values = {
    minWordCount: Number,
    maxWordCount: Number,
    answerRequired: Boolean,
    referenceRequired: Boolean,
    fileRequired: Boolean,
  };

  connect() {
    this.validateForm = this.validateForm.bind(this);
    document.querySelectorAll(".btn-next, .btn-save").forEach((button) => {
      button.addEventListener("click", this.validateForm);
    });
  }

  disconnect() {
    document.querySelectorAll(".btn-next, .btn-save").forEach((button) => {
      button.removeEventListener("click", this.validateForm);
    });
  }

  validateForm(event) {
    const errors = [];
    errors.push(...this.validateContent());
    errors.push(...this.validateBibliography());
    errors.push(...this.validateFile());

    const isTemporarySave = event.target.value === "manual";

    if (errors.length > 0) {
      event.preventDefault();
      this.updateMessages(errors);
      window.scrollTo(0, 0);
      return;
    }

    if (isTemporarySave) {
      event.preventDefault();
      this.showSuccessMessage("一時保存が完了しました。");
      window.scrollTo(0, 0);
      return;
    }

    // 確認ボタン押下時は通常のフォーム送信を行う（preventDefaultを呼ばない）
  }

  validateContent() {
    const content = this.contentTarget.value;
    const errors = [];
    const maxWordCount = parseInt(this.maxWordCountValue, 10);
    const minWordCount = parseInt(this.minWordCountValue, 10);

    console.log("Content validation:", {
      content: content.length,
      minWordCount: minWordCount,
      maxWordCount: maxWordCount,
      answerRequired: this.answerRequiredValue,
    });

    if (this.answerRequiredValue && !content) {
      errors.push("1題目の解答を入力してください。");
    }

    if (content) {
      if (maxWordCount !== 0 && content.length > maxWordCount) {
        errors.push(`1題目の解答は${maxWordCount}文字以下で入力してください。`);
      }

      if (content.match(/(.)\1{9,}/)) {
        errors.push("1題目の解答に意味のある内容を入力してください。");
      }
    }

    return errors;
  }

  validateBibliography() {
    const bibliography = this.bibliographyTarget.value;
    const errors = [];

    if (this.referenceRequiredValue && !bibliography) {
      errors.push("1題目の参考文献を入力してください。");
    }

    return errors;
  }

  validateFile() {
    const file = this.fileTarget.files[0];
    const errors = [];

    // 新しいファイルが選択されている場合は、そのファイルを検証
    if (file) {
      const validTypes = [
        "image/jpeg",
        "image/png",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel.sheet.macroEnabled.12",
      ];

      if (!validTypes.includes(file.type)) {
        errors.push("1題目の添付ファイルが添付可能な拡張子ではありません。");
      }

      if (file.size > 10 * 1024 * 1024) {
        // 10MB
        errors.push("1題目の添付ファイルのファイルサイズの上限は10MBです。");
      }
      return errors;
    }

    // 一時ファイルの存在確認
    const tempFilePath = this.fileTarget.form.querySelector(
      'input[name$="[temp_file_path]"]'
    )?.value;

    // ファイルが必須で、新しいファイルも一時ファイルも存在しない場合はエラー
    if (this.fileRequiredValue && !tempFilePath) {
      errors.push("1題目の添付ファイルを入力してください。");
    }

    return errors;
  }

  showSuccessMessage(message) {
    const messagesContainer = document.querySelector(".alert-messages");
    if (!messagesContainer) return;

    messagesContainer.innerHTML = message;
    messagesContainer.classList.remove("alert-danger", "d-none");
    messagesContainer.classList.add("alert-success");
  }

  updateMessages(errors) {
    const messagesContainer = document.querySelector(".alert-messages");
    if (!messagesContainer) return;

    // エラーメッセージの表示
    const errorList = document.createElement("ul");
    errorList.className = "mb-0";
    errors.forEach((error) => {
      const li = document.createElement("li");
      li.textContent = error;
      errorList.appendChild(li);
    });
    messagesContainer.innerHTML = "";
    messagesContainer.classList.remove("alert-success");
    messagesContainer.classList.add("alert-danger");
    messagesContainer.appendChild(errorList);
    messagesContainer.classList.remove("d-none");
  }
}
